import VersionCompareKeyValueGrid from 'components/v2/compiler/version-compare/VersionCompareKeyValueGrid';
import { VersionCompareRow } from 'components/v2/compiler/version-compare/VersionCompareRow';
import { getVersionGeneralInformationRows } from 'components/v2/compiler/version-history/content/VersionHistoryGeneralInformationGrid';
import { EpdVersionHistoryData } from 'components/v2/compiler/version-history/utils/EpdVersionHistoryDataContext';
import FilesViewList from 'components/v2/file-row/FilesViewList';
import { ImagesUpload } from 'components/v2/images-upload';
import SmartLabel from 'components/v2/labels/SmartLabel';
import React from 'react';
import { VerificationType } from 'services/EpdClient';
import ComparePanelComponent from '../../../../pages/v2/compiler/ComparePanelComponent';
import { getVersionGeneralInformationDatesRows } from '../version-history/content/VersionHistoryGeneralInformationDatesGrid';

const CompareGeneralInformationSection: React.FC<{
  data: { left: EpdVersionHistoryData | null; right: EpdVersionHistoryData | null };
}> = ({ data }) => {
  return (
    <ComparePanelComponent>
      <VersionCompareRow data={data} displayCondition={(x) => !!x}>
        {({ isLeft }) => (
          <VersionCompareKeyValueGrid
            headerText="EPD Dates"
            isLeft={isLeft}
            rowsGetter={getVersionGeneralInformationDatesRows}
          />
        )}
      </VersionCompareRow>
      <VersionCompareRow data={data} displayCondition={(x) => !!x}>
        {({ isLeft }) => (
          <VersionCompareKeyValueGrid
            headerText="General information"
            isLeft={isLeft}
            rowsGetter={getVersionGeneralInformationRows}
          />
        )}
      </VersionCompareRow>

      <VersionCompareRow
        data={data}
        displayCondition={(x) =>
          x?.thirdPartyVerification.verificationType === VerificationType.EPDProcessCertification &&
          x.thirdPartyVerification.processCertificates.length > 0
        }
        compareBy={(item) => item?.thirdPartyVerification.processCertificates.map((f) => f.name).join(',')}
      >
        {({ item, compareClassName }) => {
          const maxFilesCount = Math.max(
            data?.left?.thirdPartyVerification?.processCertificates?.length ?? 0,
            data?.right?.thirdPartyVerification?.processCertificates?.length ?? 0
          );

          return (
            <div>
              <SmartLabel label="Process certificate" />
              <FilesViewList
                className={compareClassName}
                files={item?.thirdPartyVerification.processCertificates}
                displayFilesCount={maxFilesCount}
              />
            </div>
          );
        }}
      </VersionCompareRow>

      <VersionCompareRow
        data={data}
        displayCondition={(x) => !!x?.verificationReportInfo?.verificationReports?.length}
        compareBy={(item) => item?.verificationReportInfo?.verificationReports.map((f) => f.name).join(',')}
      >
        {({ item, compareClassName }) => {
          const maxFilesCount = Math.max(
            data?.left?.verificationReportInfo?.verificationReports?.length ?? 0,
            data?.right?.verificationReportInfo?.verificationReports?.length ?? 0
          );

          return (
            <div>
              <SmartLabel label="Verification report" />
              <FilesViewList
                className={compareClassName}
                files={item?.verificationReportInfo?.verificationReports}
                displayFilesCount={maxFilesCount}
              />
            </div>
          );
        }}
      </VersionCompareRow>

      <VersionCompareRow data={data} compareBy={(x) => x?.coverPageInformation.coverPageProductImage?.name}>
        {({ item, compareClassName }) => (
          <div>
            <SmartLabel label="Product image for cover page" />
            <ImagesUpload
              name="CoverPageProductImage"
              images={
                item?.coverPageInformation.coverPageProductImage ? [item?.coverPageInformation.coverPageProductImage] : []
              }
              onUpload={() => {}}
              onReorder={() => {}}
              onRemove={() => {}}
              single
              disabled
              preferEnabledAppearanceEvenWhenDisabled
              className={compareClassName}
            />
          </div>
        )}
      </VersionCompareRow>

      <VersionCompareRow
        data={data}
        compareBy={(item) => item?.organizationInformation?.organizationImages?.map((f) => f.name).join(',')}
      >
        {({ item, compareClassName }) => (
          <div>
            <SmartLabel label="Organisation images" />
            <ImagesUpload
              className={compareClassName}
              name="OrganizationImages"
              images={item?.organizationInformation.organizationImages}
              onUpload={() => {}}
              onReorder={() => {}}
              onRemove={() => {}}
              disabled
              preferEnabledAppearanceEvenWhenDisabled
            />
          </div>
        )}
      </VersionCompareRow>

      <VersionCompareRow
        data={data}
        compareBy={(item) => item?.coverPageInformation?.companyLogoImages?.map((f) => f.name).join(',')}
      >
        {({ item, compareClassName }) => (
          <div>
            <SmartLabel label="Organisation logo" />
            <ImagesUpload
              className={compareClassName}
              name="CompanyLogoImages"
              images={item?.coverPageInformation.companyLogoImages}
              onUpload={() => {}}
              onReorder={() => {}}
              onRemove={() => {}}
              single
              disabled
              preferEnabledAppearanceEvenWhenDisabled
            />
          </div>
        )}
      </VersionCompareRow>
    </ComparePanelComponent>
  );
};

export default CompareGeneralInformationSection;
